document.addEventListener('teeinblue-event-after-cart-added', function() {
  var request = new XMLHttpRequest();
  request.open('GET', '/cart.js', true);
  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      var data = JSON.parse(this.response);
      var itemCount = data.item_count;
      var cartIcon = document.querySelector('cart-icon');
      if (cartIcon) {
            cartIcon.renderCartBubble(itemCount)
      }
    }
  };
  request.send();
});